import { Card, Col, Form, Row, Table } from 'antd';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { AddContactRecord } from './AddContactRecord';
import {
  USER_CONTACT_RECORD_FEEDBACK_NAME,
  USER_CONTACT_RECORD_TYPE_NAME,
  USER_CONTACT_RECORDS_QUERY,
} from './constants';
import { UserContactRecordType } from './type';
import { USER_CONTACT_RECORD_INTENT_NAME, UserContactRecord } from './Users';

const AddContactRecordForm: any = Form.create()(AddContactRecord);

interface State {
  roleId?: number;
  roleName: string;
  currentPage: number;
}

interface Props {
  userId: number;
}

export class ContactRecords extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      roleName: '',
      currentPage: 1,
    };
  }

  onPageChange = (currentPage: number) => {
    this.setState({
      currentPage,
    });
  };

  render() {
    const { currentPage } = this.state;
    const { userId } = this.props;
    const ids = [Number(userId)];
    return (
      <Card>
        <Row gutter={24} type={'flex'} align={'middle'} style={{ marginBottom: 10 }}>
          <Col span={4}>
            <AddContactRecordForm type={UserContactRecordType.WECHAT} userId={userId} />
          </Col>
          <Col span={20}>
            <AddContactRecordForm type={UserContactRecordType.PHONE_CALL} userId={userId} />
          </Col>
        </Row>
        <Query query={USER_CONTACT_RECORDS_QUERY} variables={{ ids }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            const [user] = data.users || {};
            const userContactrecords = (user && user.contactRecords) || [];
            let contactrecords = [];
            if (userContactrecords.length > 0) {
              contactrecords = userContactrecords.map((value: UserContactRecord) => {
                let isSuccess = '否';
                if (value.isSuccess) {
                  isSuccess = '是';
                }
                if (value.type === UserContactRecordType.WECHAT) {
                  isSuccess = '--';
                }
                const createdAt = moment(value.createdAt).utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                const feedback = USER_CONTACT_RECORD_FEEDBACK_NAME[value.feedback];
                const type = USER_CONTACT_RECORD_TYPE_NAME[value.type];
                const intent = USER_CONTACT_RECORD_INTENT_NAME[value.intent];
                const remark = value.remark;
                const teacherName = value.teacherName;
                const record = { createdAt, feedback, isSuccess, type, intent, remark, teacherName };
                return record;
              });
            }
            return (
              <Table<UserContactRecord>
                loading={loading}
                dataSource={contactrecords}
                rowKey={row => `${row.id}${row.createdAt}`}
                pagination={{ current: currentPage, onChange: this.onPageChange }}
              >
                <Table.Column dataIndex="createdAt" title="跟进时间" key="createdAt" />
                <Table.Column dataIndex="type" title="跟进类型" key="type" />
                <Table.Column dataIndex="isSuccess" title="是否接通/回复" key="isSuccess" />
                <Table.Column dataIndex="intent" title="意向度" key="intent" />
                <Table.Column dataIndex="feedback" title="用户反馈" key="feedback" />
                <Table.Column dataIndex="remark" title="跟进记录" key="remark" />
                <Table.Column dataIndex="teacherName" title="跟进老师" key="teacherName" />
              </Table>
            );
          }}
        </Query>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/ContactRecords.tsx